import { UsersThree } from "@phosphor-icons/react";

import RenderIf from "common/components/RenderIf";
import Progress from "common/components/ui/Progress";
import { Tag } from "common/components/ui/Tag";

import { useCampaignContext } from "../../../context/CampaignContext";

interface AudienceProgressProps {
  progress: number;
}

export default function AudienceProgress({ progress }: AudienceProgressProps) {
  const {
    type,
    audience_size: audienceSize,
    target_count: targetCount,
  } = useCampaignContext();

  const isList = type === "list" || type === "crm";
  const shouldShowAudienceSize = type !== "drip" && !isList;

  return (
    <article className="z-10 rounded-3xl bg-white max-lg:mb-4 lg:fixed lg:bottom-28 lg:right-6 lg:w-96 lg:border lg:border-purple-500 lg:p-3 lg:shadow-lg">
      <div className="mb-2 flex items-center text-black-700">
        <UsersThree weight="fill" size={16} />
        <span className="mx-1.5 text-button-xs">Targets</span>
        <Tag variant="secondary">{progress}%</Tag>

        <p className="ml-auto text-button-xs">
          {targetCount}
          <RenderIf condition={shouldShowAudienceSize}>
            /<span className="text-black-400">{audienceSize}</span>
          </RenderIf>
        </p>
      </div>
      <Progress value={progress} />
    </article>
  );
}
